import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import OrdersEntity, {
	ShippingInfo,
	OrderStatus,
	OrderDenialEntity,
} from '@/entities/api/orders/orders'

interface OrdersState {
	orders: OrdersEntity[]
	selectOrder: OrdersEntity | null
}

const initialState: OrdersState = {
	orders: [],
	selectOrder: null,
}

const ordersSlice = createSlice({
	name: 'orders',
	initialState,
	reducers: {
		setOrdersFn: (state, action: PayloadAction<OrdersEntity[]>) => {
			state.orders = action.payload
		},
		setOrderFn: (state, action: PayloadAction<OrdersEntity | null>) => {
			state.selectOrder = action.payload
		},
		addOrderFn: (state, action: PayloadAction<OrdersEntity>) => {
			const exists = state.orders.some(
				(order) => order._id === action.payload._id
			)
			if (!exists) state.orders.push(action.payload)
		},
		updateOrderFn: (state, action: PayloadAction<Partial<OrdersEntity>>) => {
			const index = state.orders.findIndex((o) => o._id === action.payload._id)
			if (index !== -1) {
				state.orders[index] = { ...state.orders[index], ...action.payload }
			}
		},
		updateDenialOrderFn: (
			state,
			action: PayloadAction<{ _id: string; denial: OrderDenialEntity }>
		) => {
			const order = state.orders.find((o) => o._id === action.payload._id)
			if (order) {
				order.denial = action.payload.denial
			}
			if (state.selectOrder?._id === action.payload._id) {
				state.selectOrder.denial = action.payload.denial
			}
		},

		updateStatusOrderFn: (
			state,
			action: PayloadAction<{ _id: string; status: OrderStatus }>
		) => {
			const order = state.orders.find((o) => o._id === action.payload._id)
			if (order) {
				order.status = action.payload.status
			}
			if (state.selectOrder?._id === action.payload._id) {
				state.selectOrder.status = action.payload.status
			}
		},
		updateShippingInfoOrderFn: (
			state,
			action: PayloadAction<{
				_id: string
				shipping_info: Partial<ShippingInfo>
			}>
		) => {
			const order = state.orders.find((o) => o._id === action.payload._id)
			if (order) {
				order.shipping_info = {
					...order.shipping_info,
					...action.payload.shipping_info,
				}
			}
			if (state.selectOrder?._id === action.payload._id) {
				state.selectOrder.shipping_info = {
					...state.selectOrder.shipping_info,
					...action.payload.shipping_info,
				}
			}
		},
		deleteOrderFn: (state, action: PayloadAction<string>) => {
			state.orders = state.orders.filter(
				(order) => order._id !== action.payload
			)
			if (state.selectOrder?._id === action.payload) {
				state.selectOrder = null
			}
		},
		clearOrdersFn: (state) => {
			state.orders = []
			state.selectOrder = null
		},
	},
})

export const {
	setOrdersFn,
	addOrderFn,
	updateOrderFn,
	updateStatusOrderFn,
	updateShippingInfoOrderFn,
	deleteOrderFn,
	setOrderFn,
	updateDenialOrderFn,
	clearOrdersFn,
} = ordersSlice.actions

export default ordersSlice.reducer
